import { Button } from "components/ui/button";
import { Color } from "utils/theme";
import { UsbTransferStates } from "./usb-transfer-modal";
import { Trans, useTranslation } from "react-i18next";
import { CircleCheck } from "lucide-react";

export const SuccessState = ({ data, setScreenState, onClose }) => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col justify-center items-center w-[350px]">
      <CircleCheck
        className="w-16 h-16 my-4"
        style={{ color: Color.Emerald[400] }}
      />
      <p className="mb-2 text-center">
        <Trans
          i18nKey={
            "settings.general_settings.usb_data_transfer.success_modal.description"
          }
          values={{
            0: data?.data?.trip_files_transferred ?? "-",
          }}
        >
          {
            "Successfully transferred {{0}} files. You can now safely remove the USB drive."
          }
        </Trans>
      </p>
      <Button
        onClick={() => {
          setScreenState(UsbTransferStates.Start);
          onClose();
        }}
        className="w-full mt-5"
        variant="secondary"
      >
        {t("common.close")}
      </Button>
    </section>
  );
};
